import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AppContextProvider } from './AppContext';
import EnvironmentThemeProvider from './theme/EnvironmentThemeProvider';

import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey("Moreland_Connect_LLC_MultiApp_2Devs_1Deployment_3_July_2020__MTU5MzczMDgwMDAwMA==dd56b2ef7ce988a0ba9542f61bfeb74b");


ReactDOM.render(
  <EnvironmentThemeProvider>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </EnvironmentThemeProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
